import { Role } from '@guiker/permissions'

import { RentPaymentActions } from '../permissions'
import { RentPaymentRoleNames } from '../role-names'

export const UnitManagerRole: Role = {
  name: RentPaymentRoleNames.UNIT_MANAGER,
  permissions: [{ action: RentPaymentActions.ViewRentPaymentsPlan }],
}
